import React from "react";
import { useI18n } from "@/lib/i18n";
import { Languages } from "lucide-react";

export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <button
      data-testid="lang-toggle"
      onClick={() => setLang(lang === "en" ? "te" : "en")}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 hover:bg-white/25 backdrop-blur-md text-[11px] font-bold uppercase tracking-wider transition ${className}`}
    >
      <Languages className="w-3.5 h-3.5" />
      {lang === "en" ? "EN | తె" : "తె | EN"}
    </button>
  );
}
